const locale = {
  en: {
    // common
    ETC: 'Khác',
    'GRADE.1': 'Học sinh',
    'GRADE.2': 'Giáo sư',
    'GENDER.1': 'Nữ',
    'GENDER.2': 'Nam',
    'EXIST.SHORT.1': 'N',
    'EXIST.SHORT.2': 'Y',
    'NEED.1': 'Necessary',
    'NEED.2': 'Unnecessary',
    'NEEDED.1': 'Không cần',
    'NEEDED.2': 'Cần',
    'YESORNO.1': 'Yes',
    'YESORNO.2': 'No',
    'NONE.EXIST.1': 'Không ',
    'NONE.EXIST.2': 'có',

    // error message
    'ERROR.CODE.0': 'An unknown error occurred. ErrorCode: {rc}',
    'ERROR.CODE.100':
      'There is a problem with your account. Please contact the administrator.',
    'ERROR.CODE.101':
      'Xin lỗi. Chúng tôi không thể xác thực được bạn dựa trên thông tin được cung cấp.',
    'ERROR.CODE.102': "The virtual patient's ID is incorrect",
    'ERROR.CODE.104': 'Recording paper ID is incorrect',
    'ERROR.CODE.105': 'Nursing record information not found',
    'ERROR.CODE.106':
      'You are an unauthorized user. Please contact the administrator',
    'ERROR.CODE.107': 'Vui lòng kiểm tra lại địa chỉ email và mật khẩu',
    'ERROR.CODE.108':
      'This email address has already been registered. Please enter another Email.',
    'ERROR.CODE.109':
      'This is a virtual patient ID that already exists. Please enter another ID.',
    'ERROR.CODE.110':
      'School information could not be found. Please contact the administrator.',
    'ERROR.CODE.111':
      'You do not have permission. Please contact the administrator.',
    'ERROR.CODE.113':
      'Đã tồn tại tài khoản đã đăng ký với cùng mã số sinh viên tại cùng trường.',
    'ERROR.CODE.201':
      'Insurance reimbursement code information could not be found',
    'ERROR.CODE.202': 'Drug code information could not be found',
    'ERROR.CODE.702': 'Not a valid file. Please check the file again',

    // signup
    'REQUIRED.EMAIL.FORMAT': 'Định dạng email không đúng',
    'REQUIRED.NAME.FORMAT': 'Please edit your name.',
    'REQUIRED.EMAIL.VERIFICATION':
      'Please check your email authentication code',
    'REQUIRED.PASSWORD.FORMAT':
      'Please enter the password at least 8 digits including English + numbers + special symbols.',
    'REQUIRED.PASSWORD.CONFIRM': 'The passwords you entered do not match',
    'REQUIRED.COLLEGE': 'Please select a school',
    'REQUIRED.STUDENT.NO':
      'The student number can only contain 15 or fewer digits excluding “-"',
    'REQUIRED.PASSWORD.CONFIRMTRUE':
      'Enter your password and press the confirm button.',
    'REQUIRED.PASSWORD.CONFIRMTWO': 'Please enter new password confirmation.',
    'REQUIRED.PASSWORD.RECHECKED':
      'Vui lòng nhập mật khẩu ít nhất 8 ký tự, bao gồm chữ cái, số và ký tự đặc biệt.',

    // Main
    'REQUIRED.STUDENT': 'No student has been selected.',
    'REQUIRED.PATIENT': 'No patient has been selected.',
    'PATIENT.SELECT.EMPTY.TITLE': 'Vui lòng chọn bệnh nhân.',
    'PATIENT.SELECT.EMPTY.DESCRIPTION':
      'Nhấp vào thanh tìm kiếm phía trên để tìm kiếm bệnh nhân thực hành hoặc chọn từ danh sách để kích hoạt dữ liệu chi tiết.',

    //CoreNursingSkillVideo
    'REQUIRED.VIDIEO.FORMAT': 'You cannot upload files larger than 500 MB.',

    // nursing record
    'RECORD.0': 'NANDA',
    'RECORD.1': 'SOAPIE',
    'RECORD.2': 'Focus DAR',
    'RECORD.3': 'Mô tả chi tiết',
    'RECORD.4': 'Khoá học điều dưỡng',
    'RECORD.TYPE.0': 'NANDA',
    'RECORD.TYPE.1': 'SOAPIE',
    'RECORD.TYPE.2': 'FOCUSDAR',
    'RECORD.TYPE.3': 'Mô tả chi tiết',
    'RECORD.TYPE.4': 'REMARKS',
    'NANDA.DOMAIN': 'Lĩnh vực',
    'NANDA.CLASS': 'Phân loại',
    'NANDA.DIAGNOSIS': 'Chẩn đoán',
    'NANDA.COLLECTINGDATA': 'Thu thập dữ liệu chủ quan/ khách quan',
    'NANDA.GOAL': 'Mục tiêu ngắn hạn/ dài hạn',
    'NANDA.PLAN': 'Kế hoạch điều dưỡng',
    'NANDA.INTERVENTIONS': 'Thực hiện/ Can thiệp/ Cơ sở lý thuyết điều dưỡng',
    'NANDA.EVALUATION': 'Đánh giá  điều dưỡng',
    'SOAPIE.SUBJECTIVE': 'Dữ liệu chủ quan',
    'SOAPIE.OBJECTIVE': 'Dữ liệu khách quan',
    'SOAPIE.ASSESSMENT': 'Đánh giá',
    'SOAPIE.PLANNING': 'Kế hoạch điều dưỡng',
    'SOAPIE.INTERVENTIONS': 'Thực hiện/ Can thiệp/ Cơ sở lý thuyết điều dưỡng',
    'SOAPIE.EVALUATION': 'Đánh giá điều dưỡng',
    'FOCUSDAR.FOCUS': 'Tập trung',
    'FOCUSDAR.DATA': 'Thông tin',
    'FOCUSDAR.ACTION': 'Hành động',
    'FOCUSDAR.RESPONSE': 'Phản hồi',
    'NARRATIVE.NARRATIVENOTE': 'Mô tả chi tiết',
    'REMARKS.ASSESSMENT': 'Đánh giá điều dưỡng',
    'REMARKS.DIAGNOSIS': 'Chẩn đoán điều dưỡng',
    'REMARKS.DIAGNOSISRELATE': 'Liên quan tới',
    'REMARKS.GOAL': 'Mục tiêu điều dưỡng',
    'REMARKS.PLAN': 'Kế hoạch điều dưỡng',
    'REMARKS.INTERVENTIONS': 'Thực hành can thiệp điều dưỡng',
    'REMARKS.EVALUATION': 'Đánh giá điều dưỡng',
    'REQUIRED.NONCHOICE': 'Có giá trị chưa được nhập.',
    'REQUIRED.RECORD.TIME': 'Nhập thời gian ghi chép điều dưỡng',

    // hospitalization
    'HOSPITALIZATION.PATH.1': 'OPD',
    'HOSPITALIZATION.PATH.2': 'ER',
    'HOSPITALIZATION.WAY.1': 'Tự nhập viện',
    'HOSPITALIZATION.WAY.2': 'Xe lăn',
    'HOSPITALIZATION.WAY.3': 'Xe cấp cứu',
    'HOSPITALIZATION.STATUS.1': 'Tỉnh táo',
    'HOSPITALIZATION.STATUS.2': 'Ngái ngủ',
    'HOSPITALIZATION.STATUS.3': 'Lú lẫn',
    'HOSPITALIZATION.STATUS.4': 'Bán hôn mê',
    'HOSPITALIZATION.STATUS.5': 'Hôn mê',
    'HOSPITALIZATION.STATUS02.1': 'Lưu loát',
    'HOSPITALIZATION.STATUS02.2': 'Khó khăn',
    'HOSPITALIZATION.STATUS02.3': 'Mất khả năng',

    'HOSPITALIZATION.DISEASE.HISTORY.1': 'Cao huyết áp',
    'HOSPITALIZATION.DISEASE.HISTORY.2': 'Tiểu đường',
    'HOSPITALIZATION.DISEASE.HISTORY.3': 'Bệnh lao',
    'HOSPITALIZATION.DISEASE.HISTORY.4': 'Gan',
    'HOSPITALIZATION.DISEASE.HISTORY.5': 'Ung thư',

    'HOSPITALIZATION.BODY.CYCLE.1': 'Đau ngực',
    'HOSPITALIZATION.BODY.CYCLE.2': 'Đánh trống ngực',
    'HOSPITALIZATION.BODY.CYCLE.3': 'Rối loạn nhịp tim',
    'HOSPITALIZATION.BODY.CYCLE.4': 'Máy điện tim',
    'HOSPITALIZATION.BODY.BREATH.1': 'Khó thở',
    'HOSPITALIZATION.BODY.BREATH.2': 'Ho',
    'HOSPITALIZATION.BODY.BREATH.3': 'Đờm',
    'HOSPITALIZATION.BODY.BREATH.4': 'Ho ra máu',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.1': 'Buồn nôn',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.2': 'Nôn mửa',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.3': 'Đau bụng',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.4': 'Khó nuốt',
    'HOSPITALIZATION.BODY.NERVE.1': 'Liệt',
    'HOSPITALIZATION.BODY.NERVE.2': 'Tê',
    'HOSPITALIZATION.BODY.NERVE.3': 'Dị cảm',
    'HOSPITALIZATION.BODY.NERVE.4': 'Chóng mặt',
    'HOSPITALIZATION.BODY.SKIN.1': 'Phát ban',
    'HOSPITALIZATION.BODY.SKIN.2': 'Ngứa',
    'HOSPITALIZATION.BODY.SKIN.3': 'Sưng',
    'HOSPITALIZATION.BODY.SKIN.4': 'Loét',

    'HOSPITALIZATION.HABIT.OBG.1': 'Không áp dụng',

    'HOSPITALIZATION.HABIT.FECES.1': 'Bình thường',
    'HOSPITALIZATION.HABIT.FECES.2': 'Tiêu chảy',
    'HOSPITALIZATION.HABIT.FECES.3': 'Phân đen',
    'HOSPITALIZATION.HABIT.FECES.4': 'Táo bón',
    'HOSPITALIZATION.HABIT.FECES.5': 'Hậu môn\nnhân tạo',
    'HOSPITALIZATION.HABIT.URINE.1': 'Bình thường',
    'HOSPITALIZATION.HABIT.URINE.2': 'Tiểu buốt',
    'HOSPITALIZATION.HABIT.URINE.3': 'Tiểu nhiều',
    'HOSPITALIZATION.HABIT.URINE.4': 'Tiểu không kiểm soát',
    'HOSPITALIZATION.HABIT.URINE.5': 'Phẫu thuật\nmở thông',

    'HOSPITALIZATION.FUNCTIONAL.EVALUATION.1': 'Có thể (0)',
    'HOSPITALIZATION.FUNCTIONAL.EVALUATION.2': 'Cần trợ giúp (1)',
    'HOSPITALIZATION.FUNCTIONAL.EVALUATION.3': 'Không thể (2)',

    'HOSPITALIZATION.MARRY.1': 'Kết hôn',
    'HOSPITALIZATION.MARRY.2': 'Độc thân',

    'HOSPITALIZATION.ECONOMY.MIND.1': 'Ổn định',
    'HOSPITALIZATION.ECONOMY.MIND.2': 'Lo lắng',
    'HOSPITALIZATION.ECONOMY.MIND.3': 'Buồn',
    'HOSPITALIZATION.ECONOMY.MIND.4': 'Tức giận',
    'HOSPITALIZATION.ECONOMY.MIND.5': 'Tuyệt vọng',

    'HOSPITALIZATION.EDUCATION.WAY.1': 'Lời nói',
    'HOSPITALIZATION.EDUCATION.WAY.2': 'Tài liệu',
    'HOSPITALIZATION.EDUCATION.WAY.3': 'Mô phỏng',
    'HOSPITALIZATION.EDUCATION.WAY.4': 'Lời nói + tài liệu',
    'HOSPITALIZATION.EDUCATION.CONTENTS.1': 'Bệnh',
    'HOSPITALIZATION.EDUCATION.CONTENTS.2': 'Điều trị',
    'HOSPITALIZATION.EDUCATION.CONTENTS.3': 'Thuốc',
    'HOSPITALIZATION.EDUCATION.CONTENTS.4': 'Dinh dưỡng',

    'HOSPITALIZATION.LIFE.1': 'Tự thân',
    'HOSPITALIZATION.LIFE.2': 'Giúp đỡ một phần',
    'HOSPITALIZATION.LIFE.3': 'Giúp đỡ toàn bộ',
    'HOSPITALIZATION.DESTINATION.1': 'Nhà riêng',
    'HOSPITALIZATION.DESTINATION.2': 'Bệnh viện khác',
    'HOSPITALIZATION.DESTINATION.3': 'Viện dưỡng lão',
    'HOSPITALIZATION.GUARDIAN.1': 'Không có',
    'HOSPITALIZATION.GUARDIAN.2': 'Vợ/Chồng',
    'HOSPITALIZATION.GUARDIAN.3': 'Bố',
    'HOSPITALIZATION.GUARDIAN.4': 'Mẹ',
    'HOSPITALIZATION.GUARDIAN.5': 'Con cái',

    // out hospital
    'OUT.HOSPITAL.DESTINATION.1': 'Nhà',
    'OUT.HOSPITAL.DESTINATION.2': 'Bệnh viện khác',
    'OUT.HOSPITAL.DESTINATION.3': 'Viện dưỡng lão',

    'OUT.HOSPITAL.WAY.1': 'Phương tiện\ncá nhận',
    'OUT.HOSPITAL.WAY.2': 'Phương tiện\ncông cộng',
    'OUT.HOSPITAL.WAY.3': 'Xe cứu thương',
    'OUT.HOSPITAL.WAY.4': 'Cơ sở chăm sóc',

    'OUT.HOSPITAL.FOOD.1': 'bình thường',
    'OUT.HOSPITAL.SHOWER.1': 'Vòi sen',
    'OUT.HOSPITAL.SHOWER.2': 'Bồn tắm',
    'OUT.HOSPITAL.ACTIVITY.1': 'Hạn chế',
    'OUT.HOSPITAL.ACTIVITY.2': 'Không hạn chế',

    // clinical observation
    'CLINICAL.OBSERVATION.STOP': 'Up to 5 entries per virtual patient',
    'CLINICAL.OBSERVATION.ADD.NAN':
      'Please enter only numbers for your contact information.',

    // bedScore
    'BED.SCORE.SENSORY.PERCEPTION.1': 'Giảm hoàn toàn',
    'BED.SCORE.SENSORY.PERCEPTION.2': 'Giảm nhiều',
    'BED.SCORE.SENSORY.PERCEPTION.3': 'Giảm một chút',
    'BED.SCORE.SENSORY.PERCEPTION.4': 'Bình thường',
    'BED.SCORE.HUMIDITY.1': 'Liên tục ẩm ướt',
    'BED.SCORE.HUMIDITY.2': 'Khá thường xuyên',
    'BED.SCORE.HUMIDITY.3': 'Thỉnh thoảng',
    'BED.SCORE.HUMIDITY.4': 'Hiếm khi',
    'BED.SCORE.ACTIVITY.1': 'Nằm liệt giường',
    'BED.SCORE.ACTIVITY.2': 'Phải có hỗ trợ của xe lăn\nkhi di chuyển',
    'BED.SCORE.ACTIVITY.3': 'Thỉnh thoảng đi lại',
    'BED.SCORE.ACTIVITY.4': 'Thường xuyên đi lại',
    'BED.SCORE.MOBILITY.1': 'Bất động hoàn toàn',
    'BED.SCORE.MOBILITY.2': 'Rất hạn chế',
    'BED.SCORE.MOBILITY.3': 'Hạn chế vừa phải',
    'BED.SCORE.MOBILITY.4': 'không bị giới hạn',
    'BED.SCORE.NUTRITION.1': 'Rất kém ăn',
    'BED.SCORE.NUTRITION.2': 'Kém ăn',
    'BED.SCORE.NUTRITION.3': 'Ăn tốt',
    'BED.SCORE.NUTRITION.4': 'Ăn rất tốt',
    'BED.SCORE.FRICTION.1': 'Có vấn đề',
    'BED.SCORE.FRICTION.2': 'Vấn đề tiềm tàng',
    'BED.SCORE.FRICTION.3': 'Không có vấn đề',

    // needs
    'REQUIRED.NEEDS.BODY.STATUS': '신체상태 항목을 모두 선택해주세요',

    // fall
    'FALL.1': 'Không (0 điểm)',
    'FALL.15': 'Có (15 điểm)',
    'FALL.25': 'Có (25 điểm)',
    'FALL.20': 'Có (20 điểm)',
    'FALL.WALKING.AIDS.1': 'Không/Nghỉ ngơi tại\ngiường/Y tá hỗ trợ (0 điểm)',
    'FALL.WALKING.AIDS.15': 'Nạng/gậy/bộ tập đi (15 điểm)',
    'FALL.WALKING.AIDS.30': 'Dụng cụ khác (30 điểm)',
    'FALL.GAIT.1': 'Bình thường/nghỉ ngơi trên giường/\nbất động  (0 điểm)',
    'FALL.GAIT.10': 'Yếu (10 điểm )',
    'FALL.GAIT.20': 'Bị hạn chế (20 điểm)',
    'FALL.CONSCIOUSNESS.1': 'Có thể tự chăm sóc (0 điểm)',
    'FALL.CONSCIOUSNESS.15': 'Hay quên (15 điểm)',

    // 소아낙상
    'FALLSCALE.SCORE.AGE.1': 'Dưới 3 tháng,\ntrên 13 tuổi',
    'FALLSCALE.SCORE.AGE.2': 'Trên 7 tuổi\n~ dưới 13 tuổi',
    'FALLSCALE.SCORE.AGE.3': 'Trên 3 tuổi\n~ dưới 7 tuổi',
    'FALLSCALE.SCORE.AGE.4': 'Trên 3 tháng\n~ dưới 3 tuổi',

    'FALLSCALE.SCORE.GENDER.1': 'Nữ',
    'FALLSCALE.SCORE.GENDER.2': 'Nam',

    'FALLSCALE.SCORE.DIANOSIS.1': 'Chẩn đoán khác',
    'FALLSCALE.SCORE.DIANOSIS.2': 'Rối loạn tâm thần/hành vi',
    'FALLSCALE.SCORE.DIANOSIS.3':
      'Sự thay đổi trong quá trình cung cấp oxy\n(3 loại bệnh hô hấp, mất nước, thiếu máu,\nrối loạn tiêu hoá, chóng mặt,khác)',
    'FALLSCALE.SCORE.DIANOSIS.4': 'Chẩn đoán thần kinh',

    'FALLSCALE.SCORE.COGNITIVE.1': 'Có khả năng tự chăm sóc',
    'FALLSCALE.SCORE.COGNITIVE.2': 'Trí nhớ có hạn',
    'FALLSCALE.SCORE.COGNITIVE.3': 'Giới hạn về nhận thức hoặc dưới 4 tuổi',

    'FALLSCALE.SCORE.ENVIRONMENTAL.1': 'Khu vực khám ngoại',
    'FALLSCALE.SCORE.ENVIRONMENTAL.2':
      'Sử dụng dụng cụ hỗ trợ\n(xe lăn, cây chống, nạng)',
    'FALLSCALE.SCORE.ENVIRONMENTAL.3': 'Có tiền sử té ngã',

    'FALLSCALE.SCORE.HISTORY.1': 'Nhiều hơn 48 giờ/ không có',
    'FALLSCALE.SCORE.HISTORY.2': 'Dưới 48 giờ',
    'FALLSCALE.SCORE.HISTORY.3': 'Dưới 24 giờ',

    'FALLSCALE.SCORE.DRUG.1': 'Thuốc khác/ không có',
    'FALLSCALE.SCORE.DRUG.2': 'Một trong các loại thuốc\nđược liệt kê ở trên',
    'FALLSCALE.SCORE.DRUG.3':
      'Sử dụng nhiều loại thuốc:\n(Thuốc an thần, Barbiturates, Phenothiazine,\nThuốc chống trầm cảm, Thuốc nhuận tràng/Thuốc lợi tiểu)',

    // safety
    'SAFETY.DISCOVERY.PLACE.1': 'Khu vực',
    'SAFETY.DISCOVERY.PLACE.2': 'OPD',
    'SAFETY.DISCOVERY.PLACE.3': 'Cầu thang',
    'SAFETY.DISCOVERY.PLACE.4': 'Phòng khám',
    'SAFETY.DISCOVERY.PLACE.0': 'Khác',

    'SAFETY.ACCIDENT.TYPE.1': 'Red light incident',
    'SAFETY.ACCIDENT.TYPE.2': 'Harmful incident',
    'SAFETY.ACCIDENT.TYPE.3': 'Proximity error',

    'SAFETY.ACCIDENT.CLASSIFICATION.1': 'Do thuốc',
    'SAFETY.ACCIDENT.CLASSIFICATION.2': 'Ngã hoặc chấn thương',
    'SAFETY.ACCIDENT.CLASSIFICATION.3': 'Phản ứng bất thường',
    'SAFETY.ACCIDENT.CLASSIFICATION.4': 'Biến chứng phẫu thuật',
    'SAFETY.ACCIDENT.CLASSIFICATION.5': 'Lỗi thiết bị',
    'SAFETY.ACCIDENT.CLASSIFICATION.0': 'Khác',

    'SAFETY.EVENT.CLASSIFICATION.8':
      '[Red light incident]  level 8 : patient death',
    'SAFETY.EVENT.CLASSIFICATION.7':
      '[Red light incident] level 7 : near death situation of a patient  ',
    'SAFETY.EVENT.CLASSIFICATION.6':
      '[Red light incident] level 6 : incorrect site treatment and surgery; permanent damage',
    'SAFETY.EVENT.CLASSIFICATION.5':
      '[Harmful incident]  level 5 : Hospitalization due to temporary damage or extended hospitalization period',
    'SAFETY.EVENT.CLASSIFICATION.4':
      '[Harmful incident] level 4 :  Temporary damage requires intervention(Examination, internal/surgical treatment etc.)',
    'SAFETY.EVENT.CLASSIFICATION.3':
      '[Harmful incident] level 3 : Dose given to a patient and requires further observation',
    'SAFETY.EVENT.CLASSIFICATION.2':
      '[Harmful incident] level 2 : dose given to a patient without a further harm',
    'SAFETY.EVENT.CLASSIFICATION.1':
      '[Proximity error] level 1 : Accident did not affect a patient',
    'SAFETY.EVENT.CLASSIFICATION.0':
      '[Proximity error] level 0 : accidents with errors at risk',

    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.1': 'Tỉnh táo',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.2': 'Lơ mơ',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.3': 'Không rõ ràng',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.4': 'Mê sảng',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.5': 'Hôn mê',

    'SAFETY.TYPE.ACTIVITY.STATUS.1': 'Tự thực hiện',
    'SAFETY.TYPE.ACTIVITY.STATUS.2': 'Xe lăn',
    'SAFETY.TYPE.ACTIVITY.STATUS.3': 'dụng cụ đi bộ',
    'SAFETY.TYPE.ACTIVITY.STATUS.4': 'Chỉ nằm trên giường / ghế',

    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.1': 'Phòng bệnh',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.2': 'Nhà vệ sinh',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.3': 'Phòng tắm',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.4': 'Sảnh',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.0': 'Khác',

    'SAFETY.PATIENT.RISK.FACTORS.1': 'Dáng đi\nkhông vững',
    'SAFETY.PATIENT.RISK.FACTORS.2': 'Mất thăng bằng',
    'SAFETY.PATIENT.RISK.FACTORS.3': 'Khiếm thị',
    'SAFETY.PATIENT.RISK.FACTORS.4': 'Nhu cầu tiểu tiện và đại tiện',
    'SAFETY.PATIENT.RISK.FACTORS.5': 'Ánh sáng',
    'SAFETY.PATIENT.RISK.FACTORS.6': 'Sàn nhà',
    'SAFETY.PATIENT.RISK.FACTORS.7': 'Khu vực lộn xộn',
    'SAFETY.PATIENT.RISK.FACTORS.8': 'Cần vật dụng ngoài tầm với',

    'SAFETY.PATIENT.RISK.INJURY.1': 'Không có',
    'SAFETY.PATIENT.RISK.INJURY.2': 'Đau',
    'SAFETY.PATIENT.RISK.INJURY.3': 'Bầm dập',
    'SAFETY.PATIENT.RISK.INJURY.4': 'Xuất huyết',
    'SAFETY.PATIENT.RISK.INJURY.5': 'Trầy xước',
    'SAFETY.PATIENT.RISK.INJURY.6': 'Rách da',
    'SAFETY.PATIENT.RISK.INJURY.7': 'Bong gân',
    'SAFETY.PATIENT.RISK.INJURY.8': 'Trật khớp',
    'SAFETY.PATIENT.RISK.INJURY.9': 'gãy xương',
    'SAFETY.PATIENT.RISK.INJURY.0': 'Khác',

    'SAFETY.TYPE.FALL.TYPE.1': 'While using bed',
    'SAFETY.TYPE.FALL.TYPE.2': 'While using\nmedical equipment',
    'SAFETY.TYPE.FALL.TYPE.3': 'While walking',
    'SAFETY.TYPE.FALL.TYPE.4': 'While using chair',

    'SAFETY.TYPE.RISK.FACTOR.1': 'Broken bed wheels',
    'SAFETY.TYPE.RISK.FACTOR.2': 'Lower rail',
    'SAFETY.TYPE.RISK.FACTOR.3': 'Wet floors',
    'SAFETY.TYPE.RISK.FACTOR.4': 'Too big,\ntoo small shoes',
    'SAFETY.TYPE.RISK.FACTOR.5': 'Tripping on objects',
    'SAFETY.TYPE.RISK.FACTOR.0': 'Khác',

    'SAFETY.TYPE.PRESCRIPTION.1': 'Liều lượng',
    'SAFETY.TYPE.PRESCRIPTION.2': 'Bệnh nhân',
    'SAFETY.TYPE.PRESCRIPTION.3': 'Đường dùng\nthuốc',
    'SAFETY.TYPE.PRESCRIPTION.4': 'Thuốc',
    'SAFETY.TYPE.PRESCRIPTION.0': 'Khác',

    'SAFETY.TYPE.CONFIRM.1': 'Không xác nhận',
    'SAFETY.TYPE.CONFIRM.2': 'Không kiểm tra bệnh nhân trước khi sử dụng',
    'SAFETY.TYPE.CONFIRM.3': 'Không kiểm tra thuốc trước khi sử dụng',
    'SAFETY.TYPE.CONFIRM.4': 'Không kiểm tra liều lượng trước khi sử dụng',
    'SAFETY.TYPE.CONFIRM.5': 'Không kiểm tra cách dùng trước khi sử dụng',
    'SAFETY.TYPE.CONFIRM.6': 'Không kiểm tra thẻ liều dùng trước khi sử dụng',
    'SAFETY.TYPE.CONFIRM.7': 'Không kiểm tra ngày hết hạn',

    'SAFETY.TYPE.INTERPRETATION.1': 'Lỗi diễn giải kê đơn',
    'SAFETY.TYPE.INTERPRETATION.2': 'Diễn giải sai thẻ thuốc',

    'SAFETY.OTHER.TYPE.1': 'Phản ứng bất thường',
    'SAFETY.OTHER.TYPE.2': 'Biến chứng phẫu thuật',
    'SAFETY.OTHER.TYPE.3': 'Lỗi thiết bị',
    'SAFETY.OTHER.TYPE.0': 'Khác',

    'SAFETY.ACCIDENT.RESULT.1': 'Treatment needed',
    'SAFETY.ACCIDENT.RESULT.2': 'Need in further observation',
    'SAFETY.ACCIDENT.RESULT.3': 'No need in treatment and observation',

    // KOOS
    'KOOS.SYMPTOMS.1': 'Không',
    'KOOS.SYMPTOMS.2': 'Hiếm khi',
    'KOOS.SYMPTOMS.3': 'Thi thoảng',
    'KOOS.SYMPTOMS.4': 'Thường xuyên',
    'KOOS.SYMPTOMS.5': 'Luôn luôn',

    'KOOS.STIFFNESS.1': 'Không bị',
    'KOOS.STIFFNESS.2': 'Nhẹ',
    'KOOS.STIFFNESS.3': 'Thường',
    'KOOS.STIFFNESS.4': 'Rất nhiều',
    'KOOS.STIFFNESS.5': 'Vô cùng',

    'KOOS.PAIN.1': 'Không bao giờ',
    'KOOS.PAIN.2': 'Hàng tháng',
    'KOOS.PAIN.3': 'Hàng tuần',
    'KOOS.PAIN.4': 'Hàng ngày',
    'KOOS.PAIN.5': 'Thường xuyên ',

    'KOOS.PAIN.TOW.1': 'Không',
    'KOOS.PAIN.TOW.2': 'Nhẹ',
    'KOOS.PAIN.TOW.3': 'Thường',
    'KOOS.PAIN.TOW.4': 'Rất nhiều',
    'KOOS.PAIN.TOW.5': 'Vô cùng',

    'KOOS.DAILYFUNCTION.1': 'Không khó khăn',
    'KOOS.DAILYFUNCTION.2': 'Ít',
    'KOOS.DAILYFUNCTION.3': 'Vừa',
    'KOOS.DAILYFUNCTION.4': 'Rất nhiều',
    'KOOS.DAILYFUNCTION.5': 'Vô cùng',

    'KOOS.SPORTS.1': 'Không khó khăn',
    'KOOS.SPORTS.2': 'Ít',
    'KOOS.SPORTS.3': 'Vừa',
    'KOOS.SPORTS.4': 'Rất nhiều',
    'KOOS.SPORTS.5': 'Vô cùng',

    'KOOS.LIFEQUALITY.1': 'KhônKhông bao giờg',
    'KOOS.LIFEQUALITY.2': 'Hàng tháng',
    'KOOS.LIFEQUALITY.3': 'Hàng tuần',
    'KOOS.LIFEQUALITY.4': 'Hàng ngày',
    'KOOS.LIFEQUALITY.5': 'Thường xuyên',

    'KOOS.LIFEQUALITY.TWO.1': 'Không',
    'KOOS.LIFEQUALITY.TWO.2': 'Ít',
    'KOOS.LIFEQUALITY.TWO.3': 'Thường',
    'KOOS.LIFEQUALITY.TWO.4': 'Rất nhiều',
    'KOOS.LIFEQUALITY.TWO.5': 'Hoàn toàn',

    'KOOS.LIFEQUALITY.THREE.1': 'Không khó khăn',
    'KOOS.LIFEQUALITY.THREE.2': 'Ít',
    'KOOS.LIFEQUALITY.THREE.3': 'Vừa phải',
    'KOOS.LIFEQUALITY.THREE.4': 'Rất nhiều',
    'KOOS.LIFEQUALITY.THREE.5': 'Vô cùng',

    // STarTScreening
    'STARTSCREENING.SCORE.0': 'Không (0 điểm)',
    'STARTSCREENING.SCORE.1': 'Có (1 điểm)',

    // transfusion
    'BLOOD.RECORD.SIDE.EFFECT.1': 'Y',
    'BLOOD.RECORD.SIDE.EFFECT.2': 'N',

    // dialysis
    'DIALYSIS.DIALYSIS_INFO.ROUTE.0': 'Khác',
    'DIALYSIS.DIALYSIS_INFO.ROUTE.1': 'Ngoại trú',
    'DIALYSIS.DIALYSIS_INFO.ROUTE.2': 'Phòng cấp cứu',
    'DIALYSIS.DIALYSIS_INFO.ROUTE.3': 'Nhập viện',

    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.0': 'Khác',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.1': 'AVF',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.2': 'AVG',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.3': 'Perm C',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.4': 'JVC',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.5': 'SVC',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.6': 'FVC',

    // emergency
    'EMERGENCY.ACCIDENT_TYPE.1': 'urgent',
    'EMERGENCY.ACCIDENT_TYPE.2': 'emergency',
    'EMERGENCY.ACCIDENT_TYPE.3': 'non-emergency',

    'EMERGENCY.DIVISION.1': 'Accident',
    'EMERGENCY.DIVISION.2': 'Disaster',
    'EMERGENCY.DIVISION.3': 'acute disease',
    'EMERGENCY.DIVISION.4': 'the rapid deterioration of chronic diseases',
    'EMERGENCY.DIVISION.0': 'Etc.',

    'EMERGENGY.RESULT.0': 'Nhập viện',
    'EMERGENGY.RESULT.1': 'Chuyển viện',
    'EMERGENGY.RESULT.2': 'Về Nhà',
    'EMERGENGY.RESULT.3': 'Tử vong',
    'EMERGENGY.RESULT.4': 'Khác',

    // childbirth
    'CHILDBIRTH.BABY_STATUS.GENDER.1': 'Boy',
    'CHILDBIRTH.BABY_STATUS.GENDER.2': 'Girl',

    'CHILDBIRTH.YES_OR_NO.1': 'N',
    'CHILDBIRTH.YES_OR_NO.2': 'Y',

    'CHILDBIRTH.PLACENTA_REMOVAL.METHOD.1': 'Tách bỏ tự nhiên',
    'CHILDBIRTH.PLACENTA_REMOVAL.METHOD.2': 'Tách bỏ bằng nước',

    // home_care
    'HOME_CARE.INSURANCE_TYPE.1': 'Bảo hiểm',
    'HOME_CARE.INSURANCE_TYPE.2': 'Phúc lợi',
    'HOME_CARE.INSURANCE_TYPE.3': 'Cựu\nchiến binh',

    'HOME_CARE.RESIDENCE.1': 'Căn hộ',
    'HOME_CARE.RESIDENCE.2': 'Liền\nkề',
    'HOME_CARE.RESIDENCE.3': 'Nhà\nriêng',

    'HOME_CARE.SANITARY.1': 'Tốt',
    'HOME_CARE.SANITARY.2': 'Tệ',

    'HOME_CARE.SAFETY.1': 'Tốt',
    'HOME_CARE.SAFETY.2': 'Tệ',

    // diet_nutrition
    'DIET_NUTRITION.CLASSIFICATION.1': '환자',
    'DIET_NUTRITION.CLASSIFICATION.2': '보호자',
  },
};

export default locale;
